<template>
  <b-modal
    v-model="showModal"
    :title="title"
    :hide-header="!title"
    :okTitle="okTitle"
    :ok-disabled="okDisabled"
    @ok="$emit('input-modal-confirmed', checkboxTicked)"
  >
    <slot></slot>
    <div class="my-2">
      <b-form-checkbox id="checkbox_ticked" v-model="checkboxTicked" data-test="checkbox_ticked">&nbsp;{{ checkboxMessage }}</b-form-checkbox>
    </div>
    <div v-if="checkboxTicked" class="my-2">
      <b-form-input id="input_text" v-model="inputText" data-test="input_text" :placeholder="placeholder"></b-form-input>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    checkboxMessage: {
      type: String,
      default: null,
    },
    confirmationText: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    okTitle: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      inputText: '',
      checkboxTicked: false,
    };
  },
  computed: {
    okDisabled() {
      if (this.checkboxTicked) {
        return this.confirmationText !== this.inputText;
      }
      return false;
    },
  },
  watch: {
    showModal(newVal) {
      if (!newVal) this.$emit('input-modal-cancel');
    },
  },
};
</script>
